import { motion } from "framer-motion";

const points = [
  { value: "20+", label: "Years Development & Construction Leadership" },
  { value: "23", label: "Years Hands-On Construction & Concrete Experience" },
  { value: "Local", label: "Lee's Summit Real Estate Expertise" },
  { value: "Full-Scope", label: "Residential, Commercial & Development Capabilities" },
];

export default function Credibility() {
  return (
    <section id="credibility" className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10" data-testid="credibility-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-14 lg:mb-18 lg:flex lg:items-end lg:justify-between">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F5F5F5]"
            data-testid="credibility-headline"
          >
            Built on Experience.
            <br />
            <span className="italic text-[#D4AF37]">Driven by Execution.</span>
          </motion.h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15" data-testid="credibility-grid">
          {points.map((p, i) => (
            <motion.div
              key={p.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="bg-[#0A0A0A] px-6 py-10 sm:px-8"
              data-testid={`credibility-point-${i}`}
            >
              <p className="font-display text-3xl sm:text-4xl text-[#D4AF37]">{p.value}</p>
              <span className="block w-8 h-px bg-[#D4AF37]/50 my-4" aria-hidden="true" />
              <p className="text-[11px] sm:text-xs tracking-[0.2em] uppercase leading-relaxed text-[#A3A3A3]">{p.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
